// Domain-specific images imported directly (not via ImagePath) to keep them
// out of the shared ImagePath bundle — only the matching domain's images matter.
import logoOnship from "../../assets/images/onshipDomain/logo-onship.webp";
import palCareLoginBGM from "../../assets/images/right-login-bg.webp";
import StationSatcomNewLogo from "../../assets/images/StationSatcomNewLogo.webp";
import newStationSatcomBGM from "../../assets/images/newStationSatcomBGM.webp";
import mariAppLogo from "../../assets/images/mariAppLogo.svg";
import intelsatLogin from "../../assets/images/intelsatDomain/IntelsatLogo.png";
import intelsatLoginBanner from "../../assets/images/intelsatDomain/IntelsatBGM.webp";
import VikandLogo from "../../assets/images/vikandDomain/vikandLogo.png";
import vikandLoginBanner from "../../assets/images/vikandDomain/vikand_Login_banner.webp";
import seamedixLoginBanner from "../../assets/images/seamedixsDomain/seamedixLoginBanner.webp";
import smalllogo from "../../assets/images/frontmDomain/smallLogo.webp";
import frontmLogo from "../../assets/images/frontmDomain/frontmLogo.webp";
import frontmBanner from "../../assets/images/frontmDomain/frontmBanner.webp";
import crewMattersBanner from "../../assets/images/crewmatters/crewMatters-login-background.png";
import crewMattersLogo from "../../assets/images/crewmatters/crewMatters-logo.png";

import { CREW_MATTERS_TITLE, FRONTM_TITLE, INTELSAT_TITLE, LEDGID_TITLE, ONSHIP_TITLE, VIKAND_TITLE } from "../constants";
import {
    CREW_MATTERS_FAViCON,
    ONSHIP_FAViCON, PAL_CARE_FAViCON, PAL_CARE_TITLE, SEA_DANCE_FAViCON, SEA_DANCE_TITLE, SEMEDIX_TITLE, SES_FAViCON, STATION_SATCOM_FAViCON,
    STATION_SATCOM_TITLE
} from "../constants/appHeadConfig";

const getCurrentHostname = () => {
    try {
        const hostname = new URL(window.location.href).hostname;
        // Remove trailing dots if present (e.g., dev2.frontm.com. -> dev2.frontm.com)
        return hostname.replace(/\.$/, '');
    } catch (error) {
        console.error("Invalid domain URL:", error);
        return "";
    }
};

const getDomainStatus = (targetDomain) => {
    const hostname = getCurrentHostname();
    return hostname === targetDomain;
};

//All Domains ====> 
// DEV localhost
export const PAL_CARE_DEV2 = "dev2.frontm.com"; 
export const DEV1 = "dev1.frontm.com"; 
export const LEDGID_DEV =  'ledgiddev.frontm.ai'


// STAGE
export const ONSHIP_STAGE_URL = 'stage.frontm.com';
export const VIKAND_STAGE_URL = 'stage-vikand.onship.app';
export const INTELSAT_STAGE_URL = "intelsatstage.frontm.com"  
export const STATION_ONE_STAGE_URL = "stage.stationone.io"
export const SEAMEDEX_STAGE = 'seamedixstage.onship.app';
export const STAGE_ONSHIP_URL = 'stage.onship.app';
export const LEDGID_STAGE = 'ledgidstage.frontm.ai';
export const STAGE_CREW_MATTERS = 'stage.crewmattersplus.app';


//PROD
export const INFOTAIN = 'infotain.frontm.ai';
export const ONSHIP_PROD_URL = 'onship.app';
export const STATION_ONE_PROD_URL = "stationone.io"
export const VIKAND_PROD_URL = 'vikand.frontm.com';
export const ONECARE_PROD_URL = 'onecare.frontm.com';
export const SEAMEDEX_PRODUCTION = 'app.seamedix.com';
export const PIVOTEL_PROD_URL = 'app.pulsarcommunity.com';
export const INTELSAT_PROD_URL = "intelsat.frontm.com";
export const SEA_DANCE_DOMAIN = "app.sea-dance.com";
export const SEA_DANCE_FRONTM_DOMAIN = "seadance.frontm.ai";
export const FRONTM_AI_DOMAIN = "frontm.ai";
export const INFORM_FRONTM = "inform.frontm.com"
export const INFORM_SEA_DANCE = "inform.sea-dance.com"
export const VIKAND_STAGE_2_URL = 'stage2.frontm.com';
export const VIKAND_CONNECT = 'vikandconnect.com';
export const CREW_MATTERS = 'crewmattersplus.app';

//get Domain Status
export const isPalCareDev2Domain = [PAL_CARE_DEV2].some(getDomainStatus);
export const isSeamedixDomain = [SEAMEDEX_STAGE, SEAMEDEX_PRODUCTION].some(getDomainStatus);
export const isSeaDanceDomain = [SEA_DANCE_DOMAIN, SEA_DANCE_FRONTM_DOMAIN, INFORM_FRONTM, INFORM_SEA_DANCE].some(getDomainStatus);
export const isOnshipDomain = [ONSHIP_PROD_URL, FRONTM_AI_DOMAIN, DEV1, ONSHIP_STAGE_URL,STAGE_ONSHIP_URL].some(getDomainStatus);
export const isIntelsatDomain = [INTELSAT_PROD_URL,INTELSAT_STAGE_URL].some(getDomainStatus);
export const isVikandDomain = [VIKAND_PROD_URL, VIKAND_STAGE_URL,VIKAND_STAGE_2_URL, VIKAND_CONNECT].some(getDomainStatus);
export const isFrontmAiDomain = [FRONTM_AI_DOMAIN].some(getDomainStatus);
export const isStageOnshipDomain = [STAGE_ONSHIP_URL].some(getDomainStatus);
export const isLedgidDomain = [LEDGID_DEV,LEDGID_STAGE].some(getDomainStatus);
export const isCrewMattersDomain = [CREW_MATTERS, STAGE_CREW_MATTERS].some(getDomainStatus);



export const getDomainConfig = () => {
    const domainGroups = [
        {
            name: "Ledgid",
            domains: [LEDGID_DEV, LEDGID_STAGE],
            logo: logoOnship,
            banner: palCareLoginBGM,
            title: LEDGID_TITLE,
            favicon: ONSHIP_FAViCON,
        },
        {
            name: "Intelsat",
            domains: [INTELSAT_PROD_URL, INTELSAT_STAGE_URL],
            logo: intelsatLogin,
            banner: intelsatLoginBanner,
            title: INTELSAT_TITLE,
            favicon: SES_FAViCON,
        },
        {
            name: "PalCareDev2",
            domains: [PAL_CARE_DEV2],
            logo: mariAppLogo,
            banner: palCareLoginBGM,
            title: PAL_CARE_TITLE,
            favicon: PAL_CARE_FAViCON,
        },
        {
            name: "Seamedix",
            domains: [SEAMEDEX_STAGE, SEAMEDEX_PRODUCTION],
            logo: mariAppLogo,
            banner: seamedixLoginBanner,
            title: SEMEDIX_TITLE,
            favicon: PAL_CARE_FAViCON,
        },
        {
            name: "Vikand",
            domains: [VIKAND_PROD_URL, VIKAND_STAGE_URL,VIKAND_STAGE_2_URL, VIKAND_CONNECT],
            logo: VikandLogo,
            banner: vikandLoginBanner,
            title: VIKAND_TITLE,
            favicon: ONSHIP_FAViCON,
        },
        {
            name: "SeaDance",
            domains: [SEA_DANCE_DOMAIN, SEA_DANCE_FRONTM_DOMAIN, INFORM_FRONTM, INFORM_SEA_DANCE],
            logo: smalllogo,
            banner: palCareLoginBGM,
            title: SEA_DANCE_TITLE,
            favicon: SEA_DANCE_FAViCON,
        },
        {
            name: "Onship",
            domains: [ONSHIP_PROD_URL, DEV1, ONSHIP_STAGE_URL, STAGE_ONSHIP_URL],
            logo: logoOnship,
            banner: palCareLoginBGM,
            title: ONSHIP_TITLE,
            favicon: ONSHIP_FAViCON,
        },
         {
            name: "Frontm",
            domains: [ FRONTM_AI_DOMAIN],
            logo: frontmLogo,
            banner: frontmBanner,
            title: FRONTM_TITLE,
            favicon: ONSHIP_FAViCON,
        },
         {
            name: "CrewMatters",
            domains: [ CREW_MATTERS, STAGE_CREW_MATTERS],
            logo: crewMattersLogo,
            banner: crewMattersBanner,
            title: CREW_MATTERS_TITLE,
            favicon: CREW_MATTERS_FAViCON,
        }
    ];

    // Check which domain matches
    for (const group of domainGroups) {
        if (group.domains.some(getDomainStatus)) {
            return group;
        }
    }

    // Default config
    return {
        name: "StationSatcom",
        logo: StationSatcomNewLogo,
        banner: newStationSatcomBGM,
        title: STATION_SATCOM_TITLE,
        favicon: STATION_SATCOM_FAViCON,
    };
};
